import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { connect } from 'react-redux';
import { patchUser } from 'redux/settings/actions';

import CommonInputField
  from 'components/elements/inputs/CommonInputField';

import { emailValidation } from 'utils/validations/email';

import './CommerceContactEmail.css';


function CommerceContactEmail(props) {
  const {
    paymentProviders,
    me,
    patchUser,
    patchUserError,
  } = props;
  const { t } = useTranslation();

  if (paymentProviders && paymentProviders.length === 0) return null;

  return (
    <div className="commerce-contact-email__component">
      <div className="label">
        {t("Contact email (optional)")}
      </div>
      <div className="text">
        {t("This contact email address will be shown on  all invoices your visitors receive once they pay")}
      </div>

      <CommonInputField
        key="commerce-contact-email-input-key"
        placeholder="Contact email"
        initialValue={me.commerce_contact_email}
        executedFunction={value => {
          const form = new FormData();
          form.append('commerce_contact_email', value);
          patchUser(form);
        }}
        serverErrors={patchUserError &&
          patchUserError.commerce_contact_email && patchUserError.commerce_contact_email[0]}
        validationFunction={emailValidation}
      />
    </div>
  );
}

CommerceContactEmail.propTypes = {
  patchUser: PropTypes.func.isRequired,
  paymentProviders: PropTypes.arrayOf(PropTypes.shape),
  me: PropTypes.object,
  patchUserError: PropTypes.object,
};

CommerceContactEmail.defaultProps = {
  paymentProviders: null,
  me: null,
  patchUserError: null,
};

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
    patchUserError: state.settingsReducer.patchUserError,
  }
);

export default connect(
  mapStateToProps,
  {
    patchUser,
  },
)(CommerceContactEmail);
